import Swiper, { Navigation, Pagination } from 'swiper'

export default function contactPersons () {
  document.addEventListener('DOMContentLoaded', () => {
    const widgets = document.querySelectorAll('.mtt-contact-persons')

    if (!widgets.length) {
      return
    }

    widgets.forEach((widget) => {
      const swiperElement = widget.querySelector('.swiper')
      const pagination = widget.querySelector('.swiper-pagination')
      const prevArrow = widget.querySelector('.mtt-contact-persons__arrow--prev')
      const nextArrow = widget.querySelector('.mtt-contact-persons__arrow--next')
      const slideCount = widget.querySelectorAll('.swiper-slide').length

      if (!swiperElement) {
        return
      }

      const swiper = new Swiper(swiperElement, {
        modules: [Navigation, Pagination],
        spaceBetween: 40,
        pagination: {
          el: pagination,
          clickable: true,
        },
        navigation: {
          prevEl: prevArrow,
          nextEl: nextArrow,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: Math.min(slideCount, 2),
          },
          1280: {
            slidesPerView: Math.min(slideCount, 3),
          },
        },
      })
    })
  })
}
